module.exports = __webpack_public_path__ + "img/38.1e20763d.png";